import React from 'react';
import {inject, observer} from 'mobx-react';
import {RouteComponentProps} from 'react-router-dom';
import {UserStoreTypes} from '@/stores/user';
import {View, Input, Button, Typography} from '@/components';
import {Row, Col, Checkbox, message} from 'antd';
import {useEffectOnce, useLocalStorage} from 'react-use';
import useReactRouter from 'use-react-router';
import {checkMobile, checkPassword} from '@/utils/RegExps';
import log from '@/utils/log';

export interface PropsType {
    UserStore: UserStoreTypes;
}

export type SignInProps = PropsType & RouteComponentProps;

const SignIn: React.FC<SignInProps> = inject('UserStore')(observer(props => {
    
    const {SignInStore} = props.UserStore.AccountStore;
    const {history} = useReactRouter();
    const [userInfo]: any = useLocalStorage('userInfo');
    const [remember, setRemember] = useLocalStorage('rememberState');
    
    useEffectOnce(() => {
      log({pageId: 'P01', eventId: 'E0100',ext: ''})
        const state = typeof remember === 'string' ? false : Boolean(remember)
        SignInStore.setRememberState(state)
        if(state && typeof userInfo === 'object') {
            const {mobile, passwordLength} = userInfo
            SignInStore.setUserAccount({
                mobile: mobile,
                password: Math.random().toString().slice(passwordLength)
            })
        } else {
            SignInStore.setUserAccount({
                mobile: '',
                password: ''
            })
        }
    })
    
    const handleSigninOnClick = async() => {
      
      log({pageId: 'P01', eventId: 'E0101',ext: ''})
  
      if(!checkMobile(SignInStore.userAccount.mobile)) {
            message.error('请输入正确手机号')
            return
        }
      
        if(!checkPassword(SignInStore.userAccount.password)) {
            message.error('请输入密码')
            return
        }
      
        const {rememberState} = SignInStore;
        if(rememberState && userInfo) {
            userInfo.mobile === SignInStore.userAccount.mobile ?
                await SignInStore.signinTocken({mobile: userInfo.mobile}) :
                await SignInStore.signin()
            return
        }
        await SignInStore.signin()
    }
    
    const handleCheckboxOnChange = (e: { target: { checked: boolean } }) => {
      log({pageId: 'P01', eventId: 'E0104',ext: String(e.target.checked)})
      setRemember(e.target.checked)
        SignInStore.setRememberState(e.target.checked)
    }
    
    const handleSignupOnClick = () => {
      log({pageId: 'P01', eventId: 'E0102',ext: ''})
      history.push('SignUp')
    }
    
    const handleForgetOnClick = () => {
      log({pageId: 'P01', eventId: 'E0103',ext: ''})
        history.push('Forget')
    }
    
    const handleInputOnChange = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
        SignInStore.setUserAccount({[key]: e.target.value})
    }
    
    return (
      <>
        <Typography.Title level={1}>登录</Typography.Title>
        <Row gutter={[16, 16]}>
            <Col><Input value={SignInStore.userAccount.mobile} onChange={(e) => handleInputOnChange(e, 'mobile')}
                size='large' placeholder='请输入您的手机号'/></Col>
            <Col><Input value={SignInStore.userAccount.password} onChange={(e) => handleInputOnChange(e, 'password')}
                size='large' type='password' placeholder='请输入密码'/></Col>
            <Col>
                <Row gutter={[16, 16]} type='flex' justify='space-between' align='middle'>
                    <Col><Checkbox checked={SignInStore.rememberState} onChange={handleCheckboxOnChange}>记住密码</Checkbox></Col>
                    <Col><Button onClick={handleForgetOnClick} type="link">忘记密码</Button></Col>
                </Row>
            </Col>
            <Col><Button onClick={handleSigninOnClick} type="primary" size='xl' block>登录</Button></Col>
            <Col><Button onClick={handleSignupOnClick} type="primary" size='xl' block ghost>注册</Button></Col>
        </Row>
      </>
    )
    
}
))

export default View.AccountView(SignIn);
